import { skipToken, useQuery } from '@tanstack/react-query'

import { dataOrThrow, type GetPatientSubscriptionCancelQuery } from '@snootsvet/shared'

import { useOsApi } from '@/frontend/hooks/api/use-os-api'

export function useGetPatientSubscriptionCancel(
  patientId: string,
  query: GetPatientSubscriptionCancelQuery | null
) {
  const api = useOsApi()
  return useQuery({
    queryKey: ['cancellation-quote', patientId, query],
    queryFn: query
      ? async () =>
          dataOrThrow(
            await api.get('/patients/:patientId/subscription/cancel', {
              params: { patientId },
              query,
            })
          )
      : skipToken,
    refetchOnWindowFocus: false,
    retry: false,
  })
}
